var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import query from 'syf-component-library/const/mediaQueries';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
import useMediaQuery from '../../../hooks/use-media-query';
import PaymentOptionsBanner from '../../../ui/common/PaymentOptionsBanner';
import { StyledFlex } from '../../../ui/subcomponents';
import OptionCard from './OptionCard';
import { StyledContent } from './subcomponents';
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
export var PaymentOptions = function (_a) {
    var isLoading = _a.isLoading, paymentOptions = _a.paymentOptions;
    var isMobile = useMediaQuery(query.lessThanSmall);
    var padding = isMobile ? 'large' : 'xlarge';
    useTriggerAnalyticsEvent({
        featureEvent: 'paymentOptions',
        shouldTrigger: !isLoading
    });
    return (_jsxs(_Fragment, { children: [_jsx(PaymentOptionsBanner, {}), _jsx(StyledContent, __assign({ all: padding }, { children: _jsx(StyledFlex, __assign({ direction: "column", alignItems: "center", justifyContent: "center" }, { children: isLoading ? (_jsx(SyfLoader, { size: 2.5 })) : (paymentOptions.map(function (option) { return (_jsx(OptionCard, __assign({}, option), option.heading)); })) })) }))] }));
};
//# sourceMappingURL=index.js.map